import { tenantFormValidators } from "./tenantFormValidators.ts";
import { legalRepFormValidators } from "./legalRepFormValidators.ts";
import { leaseContractValidators } from "./leaseContractValidators.ts";
import { landlordFormValidators } from "./landlordFormValidators.ts";
import { commercialReferenceValidators } from "./commercialReferenceValidators.ts";
import { businessFormValidators } from "./businessFormValidators.ts";
import { personalReferenceValidators } from "./personalReferenceValidators.ts";
import { guarantorFormValidators } from "./guarantorFormValidators.ts";

export const allFormsValidators: any = {
  ...tenantFormValidators,
  ...legalRepFormValidators,
  ...leaseContractValidators,
  ...landlordFormValidators,
  ...guarantorFormValidators,
  ...commercialReferenceValidators,
  ...businessFormValidators,
  ...personalReferenceValidators,
};
